// top, left, right face colours per box state
const FACES = {
  need: ["#fde68a", "#f59e0b", "#d97706"],
  dims: ["#bfdbfe", "#60a5fa", "#2563eb"],
  ready: ["#a7f3d0", "#34d399", "#059669"],
};

export default function BoxCube({ state, className }) {
  const [top, left, right] = FACES[state];
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <polygon points="32,6 58,20 32,34 6,20" fill={top} />
      <polygon points="6,20 32,34 32,60 6,46" fill={left} />
      <polygon points="58,20 32,34 32,60 58,46" fill={right} />
      <path d="M19 13 L45 27" stroke="rgba(255,255,255,.55)" strokeWidth="5" />
      <polygon points="38,38 52,30.5 52,41 38,48.5" fill="rgba(255,255,255,.75)" />
    </svg>
  );
}
